export default __webpack_public_path__ + "static/media/Q15_4_resized.4c26c5a2.jpg";